const PORTAL_POSTFIX = '__portal'

export const COURSE_TOOLTIP = `courseTooltip${PORTAL_POSTFIX}`
export const COURSE_TOOLTIP_TEST_MATCHING = `courseTooltipTestMatching${PORTAL_POSTFIX}`
